module.exports.getObjectValue = function(
	path,
	object,
	defaultValue = null,
	allowFalse = false,
	allowLooseComparison = false
) {
	if (typeof path == "string") {
		path = path.split(".");
	}

	return path.reduce((carry, key) => {
		if (carry && carry[key]) {
			return carry[key];
		}

		if (allowFalse && allowLooseComparison && carry[key] == false) {
			return carry[key];
		}

		if (allowFalse && carry[key] === false) {
			return carry[key];
		}

		return defaultValue;
	}, object);
};

Object.compare = function(obj1, obj2) {
	//Loop through properties in object 1
	for (var p in obj1) {
		//Check property exists on both objects
		if (obj1.hasOwnProperty(p) !== obj2.hasOwnProperty(p)) return false;

		switch (typeof obj1[p]) {
			//Deep compare objects
			case "object":
				if (!Object.compare(obj1[p], obj2[p])) return false;
				break;
			//Compare function code
			case "function":
				if (
					typeof obj2[p] == "undefined" ||
					(p != "compare" && obj1[p].toString() != obj2[p].toString())
				)
					return false;
				break;
			//Compare values
			default:
				if (obj1[p] != obj2[p]) return false;
		}
	}

	//Check object 2 for any extra properties
	for (var p in obj2) {
		if (typeof obj1[p] == "undefined") return false;
	}
	return true;
};

module.exports.isEquivalent = function(a, b) {
	return Object.compare(a, b);
};

module.exports.computedUserSetting = function(name, persistent = false) {
	let set = function(value) {
		if (persistent) {
			this.setUserSettingValue({
				name,
				value
			});
		} else {
			this.SET_VALUE({
				name,
				value
			});
		}
	};
	return {
		get() {
			return this[`_displaySetting`](name, persistent);
		},
		set
	};
};

module.exports.paramString = function(params) {
	return (
		"?" +
		Object.keys(params)
			.map(key => key + "=" + params[key])
			.join("&")
	);
};

module.exports.sortCategories = categories => {
	if (!Array.isArray(categories)) {
		return;
	}

	return categories.sort((a, b) => {
		if (typeof a.order === "number" && typeof b.order === "number") {
			return a.order - b.order;
		} else if (typeof a.order === "number") {
			return -1;
		} else if (typeof b.order === "number") {
			return 1;
		}

		return 0;
	});
};
